import * as i0 from '@angular/core';
import * as i1 from './select.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '@angular/cdk/bidi';
import * as i6 from '@angular/cdk/scrolling';
import * as i7 from '@angular/cdk/overlay';
import * as i8 from '@angular/cdk/portal';
import * as i9 from '../cdk/overlay/mapping';
import * as i10 from '../cdk/overlay/overlay-container';
import * as i11 from '../button/button.component';
import * as i12 from '../input/input.directive';
import * as i13 from '../card/card.component';
import * as i14 from '../card/reveal-card/reveal-card.component';
import * as i15 from '../card/flip-card/flip-card.component';
import * as i16 from '../card/shared/shared.component';
import * as i17 from '../checkbox/checkbox.component';
import * as i18 from './select.component';
import * as i19 from './option.component';
import * as i20 from './option-group.component';
import * as i21 from '../shared/shared.module';
import * as i22 from '../cdk/overlay/overlay.module';
import * as i23 from '../button/button.module';
import * as i24 from '../input/input.module';
import * as i25 from '../card/card.module';
import * as i26 from '../checkbox/checkbox.module';
export const NbSelectModuleNgFactory:i0.NgModuleFactory<i1.NbSelectModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_bh = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_s = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.ɵangular_packages_forms_forms_be = (<any>(null as any));
var _decl0_16:i3.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_38:i5.Dir = (<any>(null as any));
var _decl0_39:i6.CdkFixedSizeVirtualScroll = (<any>(null as any));
var _decl0_40:i6.CdkScrollable = (<any>(null as any));
var _decl0_41:i6.CdkVirtualForOf<any> = (<any>(null as any));
var _decl0_42:i6.CdkVirtualScrollViewport = (<any>(null as any));
var _decl0_43:i7.CdkConnectedOverlay = (<any>(null as any));
var _decl0_44:i7.CdkOverlayOrigin = (<any>(null as any));
var _decl0_45:i8.CdkPortal = (<any>(null as any));
var _decl0_46:i8.CdkPortalOutlet = (<any>(null as any));
var _decl0_47:i9.NbPortalDirective = (<any>(null as any));
var _decl0_48:i9.NbPortalOutletDirective = (<any>(null as any));
var _decl0_49:i10.NbOverlayContainerComponent = (<any>(null as any));
var _decl0_50:i11.NbButtonComponent = (<any>(null as any));
var _decl0_51:i12.NbInputDirective = (<any>(null as any));
var _decl0_52:i13.NbCardComponent = (<any>(null as any));
var _decl0_53:i13.NbCardBodyComponent = (<any>(null as any));
var _decl0_54:i13.NbCardFooterComponent = (<any>(null as any));
var _decl0_55:i13.NbCardHeaderComponent = (<any>(null as any));
var _decl0_56:i14.NbRevealCardComponent = (<any>(null as any));
var _decl0_57:i15.NbFlipCardComponent = (<any>(null as any));
var _decl0_58:i16.NbCardFrontComponent = (<any>(null as any));
var _decl0_59:i16.NbCardBackComponent = (<any>(null as any));
var _decl0_60:i17.NbCheckboxComponent = (<any>(null as any));
var _decl0_61:i18.NbSelectComponent<any> = (<any>(null as any));
var _decl0_62:i19.NbOptionComponent<any> = (<any>(null as any));
var _decl0_63:i20.NbOptionGroupComponent = (<any>(null as any));
var _decl0_64:i18.NbSelectLabelComponent = (<any>(null as any));
var _decl0_65:i2.AsyncPipe = (<any>(null as any));
var _decl0_66:i2.UpperCasePipe = (<any>(null as any));
var _decl0_67:i2.LowerCasePipe = (<any>(null as any));
var _decl0_68:i2.JsonPipe = (<any>(null as any));
var _decl0_69:i2.SlicePipe = (<any>(null as any));
var _decl0_70:i2.DecimalPipe = (<any>(null as any));
var _decl0_71:i2.PercentPipe = (<any>(null as any));
var _decl0_72:i2.TitleCasePipe = (<any>(null as any));
var _decl0_73:i2.CurrencyPipe = (<any>(null as any));
var _decl0_74:i2.DatePipe = (<any>(null as any));
var _decl0_75:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_76:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_77:i2.KeyValuePipe = (<any>(null as any));
var _decl0_78:i21.NbSharedModule = (<any>(null as any));
var _decl0_79:i22.NbOverlayModule = (<any>(null as any));
var _decl0_80:i23.NbButtonModule = (<any>(null as any));
var _decl0_81:i24.NbInputModule = (<any>(null as any));
var _decl0_82:i25.NbCardModule = (<any>(null as any));
var _decl0_83:i26.NbCheckboxModule = (<any>(null as any));
var _decl0_84:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_85:i0.ElementRef<any> = (<any>(null as any));
function _View_NbSelectComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NbSelectComponent_1_2():void {
  if ((((_decl0_61.selectionModel == null)? (null as any): _decl0_61.selectionModel.length) && _decl0_61.customLabel)) { var _any:any = (null as any); }
}
function _View_NbSelectComponent_1_3():void {
  if ((((_decl0_61.selectionModel == null)? (null as any): _decl0_61.selectionModel.length) && !_decl0_61.customLabel)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_61.selectionView;
    currVal_0;
  }
}
function _View_NbSelectComponent_1_1():void {
  if (((_decl0_61.selectionModel == null)? (null as any): _decl0_61.selectionModel.length)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_61.customLabel;
    currVal_0;
    const currVal_1:any = !_decl0_61.customLabel;
    currVal_1;
  }
}
function _View_NbSelectComponent_1_4():void {
  if (!((_decl0_61.selectionModel == null)? (null as any): _decl0_61.selectionModel.length)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_61.placeholder;
    currVal_0;
  }
}
function _View_NbSelectComponent_1_5():void {
  var _any:any = (null as any);
  const currVal_0:any = 'select';
  currVal_0;
  const currVal_1:any = [_decl0_61.status,_decl0_61.overlayPosition];
  currVal_1;
  const currVal_2:any = _decl0_52.xxsmall;
  currVal_2;
  const currVal_3:any = _decl0_52.xsmall;
  currVal_3;
  const currVal_4:any = _decl0_52.small;
  currVal_4;
  const currVal_5:any = _decl0_52.medium;
  currVal_5;
  const currVal_6:any = _decl0_52.large;
  currVal_6;
  const currVal_7:any = _decl0_52.xlarge;
  currVal_7;
  const currVal_8:any = _decl0_52.xxlarge;
  currVal_8;
  const currVal_9:any = _decl0_52.active;
  currVal_9;
  const currVal_10:any = _decl0_52.disabled;
  currVal_10;
  const currVal_11:any = _decl0_52.primary;
  currVal_11;
  const currVal_12:any = _decl0_52.info;
  currVal_12;
  const currVal_13:any = _decl0_52.success;
  currVal_13;
  const currVal_14:any = _decl0_52.warning;
  currVal_14;
  const currVal_15:any = _decl0_52.danger;
  currVal_15;
  const currVal_16:any = _decl0_52.hasAccent;
  currVal_16;
  const currVal_17:any = _decl0_52.primaryAccent;
  currVal_17;
  const currVal_18:any = _decl0_52.infoAccent;
  currVal_18;
  const currVal_19:any = _decl0_52.successAccent;
  currVal_19;
  const currVal_20:any = _decl0_52.warningAccent;
  currVal_20;
  const currVal_21:any = _decl0_52.dangerAccent;
  currVal_21;
  const currVal_22:any = _decl0_52.activeAccent;
  currVal_22;
  const currVal_23:any = _decl0_52.disabledAccent;
  currVal_23;
  const currVal_24:any = _decl0_61.hostWidth;
  currVal_24;
}
function _View_NbSelectComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_61.overlayPosition;
  currVal_0;
  const currVal_1:any = _decl0_61.size;
  currVal_1;
  const currVal_2:any = _decl0_61.status;
  currVal_2;
  const currVal_3:any = _decl0_61.shape;
  currVal_3;
  const currVal_4:any = _decl0_61.hero;
  currVal_4;
  const currVal_5:any = _decl0_61.disabled;
  currVal_5;
  const currVal_6:any = _decl0_61.fullWidth;
  currVal_6;
  const currVal_7:any = _decl0_61.outline;
  currVal_7;
  const currVal_8:any = _decl0_50.xsmall;
  currVal_8;
  const currVal_9:any = _decl0_50.small;
  currVal_9;
  const currVal_10:any = _decl0_50.medium;
  currVal_10;
  const currVal_11:any = _decl0_50.large;
  currVal_11;
  const currVal_12:any = _decl0_50.primary;
  currVal_12;
  const currVal_13:any = _decl0_50.info;
  currVal_13;
  const currVal_14:any = _decl0_50.success;
  currVal_14;
  const currVal_15:any = _decl0_50.warning;
  currVal_15;
  const currVal_16:any = _decl0_50.danger;
  currVal_16;
  const currVal_17:any = _decl0_50.rectangle;
  currVal_17;
  const currVal_18:any = _decl0_50.round;
  currVal_18;
  const currVal_19:any = _decl0_50.semiRound;
  currVal_19;
  const currVal_20:any = _decl0_50.hero;
  currVal_20;
  const currVal_21:any = _decl0_50.outline;
  currVal_21;
  const currVal_22:any = _decl0_50.disabled;
  currVal_22;
  const currVal_23:any = _decl0_50.disabled;
  currVal_23;
  const currVal_24:any = _decl0_50.tabbable;
  currVal_24;
  const currVal_25:any = _decl0_50.fullWidth;
  currVal_25;
  const currVal_26:any = _decl0_61.isOpened;
  currVal_26;
  const currVal_27:any = ((_decl0_61.selectionModel == null)? (null as any): _decl0_61.selectionModel.length);
  currVal_27;
  const currVal_28:any = !((_decl0_61.selectionModel == null)? (null as any): _decl0_61.selectionModel.length);
  currVal_28;
  const pd_29:any = ((<any>_decl0_50.onClick(_any)) !== false);
  const pd_30:any = ((<any>_decl0_61.trySetTouched()) !== false);
}
function _View_NbOptionComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_62.selectedClass;
  currVal_0;
  const currVal_1:any = _decl0_62.disabledClass;
  currVal_1;
  const pd_2:any = ((<any>_decl0_62.onClick()) !== false);
}
function _View_NbOptionComponent_2_2():void {
  if (_decl0_62.withCheckbox) { var _any:any = (null as any); }
}
function _View_NbOptionComponent_2_1():void {
  if (_decl0_62.withCheckbox) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_60.success;
    currVal_0;
    const currVal_1:any = _decl0_60.warning;
    currVal_1;
    const currVal_2:any = _decl0_60.danger;
    currVal_2;
    const currVal_3:any = _decl0_62.selected;
    currVal_3;
    const currVal_4:any = _decl0_21.ngClassUntouched;
    currVal_4;
    const currVal_5:any = _decl0_21.ngClassTouched;
    currVal_5;
    const currVal_6:any = _decl0_21.ngClassPristine;
    currVal_6;
    const currVal_7:any = _decl0_21.ngClassDirty;
    currVal_7;
    const currVal_8:any = _decl0_21.ngClassValid;
    currVal_8;
    const currVal_9:any = _decl0_21.ngClassInvalid;
    currVal_9;
    const currVal_10:any = _decl0_21.ngClassPending;
    currVal_10;
    const currVal_11:any = _decl0_84;
    currVal_11;
    const pd_12:any = ((<any>(_decl0_62.selected = _any)) !== false);
  }
}
function _View_NbOptionComponent_2_4():void {
  if (!_decl0_62.withCheckbox) { var _any:any = (null as any); }
}
function _View_NbOptionComponent_2_3():void {
  if (!_decl0_62.withCheckbox) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_84;
    currVal_0;
  }
}
function _View_NbOptionComponent_2_5():void {
  var _any:any = (null as any);
}
function _View_NbOptionComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_62.withCheckbox;
  currVal_0;
  const currVal_1:any = !_decl0_62.withCheckbox;
  currVal_1;
}
function _View_NbOptionGroupComponent_Host_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_63.disabledClass;
  currVal_0;
}
function _View_NbOptionGroupComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_63.title;
  currVal_0;
}
function _View_NbSelectLabelComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_NbSelectLabelComponent_4_0():void {
  var _any:any = (null as any);
}
